<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div class="talent-info">
		<yx-avatar :size="40" :src="row.head" />
		<div class="right">
			<template v-if="row.anchor_id !== 0">
				<div class="ellipsis">{{ row.anchor_name }}</div>
				<div class="number">
					<platform-icon :platformId="row.platform_id"></platform-icon>
					<div class="ellipsis">ID：{{ row.anchor_account }}</div>
				</div>
				<div>粉丝数 {{ row.fans_num }}</div>
			</template>
			<el-tooltip v-else placement="top" content="默认生成，所有未选中达人信息生成的合作进度，都记录在该项">
				<span style="line-height: 40px">无达人信息</span>
			</el-tooltip>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {
		
	},
};
</script>
<style lang="less" scoped>
.talent-info {
	display: flex;

	.right {
		margin-left: 8px;
		font-size: 14px;
		color: #666;
		flex: 1;
		overflow: hidden;

		.ellipsis {
			color: #333;
		}

		.number {
			display: flex;
			align-items: center;

			.ellipsis {
				margin-left: 8px;
				flex: 1;
				overflow: hidden;
				color: #666;
			}
		}
	}
}
</style>
